import { type GoalsExperienceResponse } from '../../../models/goal';

export const devPreviewQuote = {
  text: 'Momentum comes from consistent reflection and the willingness to adjust before small issues become large ones.',
  author: 'BestHuman Dev Preview'
};

export const baseGoalsExperience: GoalsExperienceResponse = {
  activePackage: null,
  draft: null
};
